import { cropConnectApiClient } from '../cropConnectApiClient';
import {
  AnswerOption,
  BaseQuestion,
  ProductApiResponse,
  QuestionType,
} from '../../presentation/features/variety-planner/types';
import { GetProductsParams } from '../../presentation/features/variety-planner/api-types';

export const fetchQuestions = async (): Promise<BaseQuestion[]> => {
  try {
    const { data } = await cropConnectApiClient.getQuestions();

    if (!data) {
      console.error(
        'Variety Planner: Failed to retrieve questions, received empty response'
      );
      return [];
    }

    return data
      .sort(
        (firstItem, secondItem) =>
          (firstItem?.order ?? 0) - (secondItem?.order ?? 0)
      )
      .map((question) => ({
        id: question.id as string,
        tag: question.tag as string,
        hasInfo: question.hasInfo as boolean,
        type: question.type as QuestionType,
        options: question.options as AnswerOption[],
        defaultSelection: question.defaultSelection as string[],
      }));
  } catch (e) {
    console.error('Variety Planner questions failed to:', e);
    return [];
  }
};

export const fetchProductsBasedOnAnswers = async ({
  answers,
  skip,
  take,
  sortDirection,
  sortProperty,
}: GetProductsParams): Promise<ProductApiResponse> => {
  try {
    const { data } = await cropConnectApiClient.getProducts(
      skip,
      take,
      sortDirection,
      sortProperty,
      answers
    );

    if (!data || !data.items) {
      console.error(
        'Variety Planner : Failed to retrieve products, received empty response'
      );
      return { products: [], totalCount: 0 };
    }

    const products = data.items.map((product) => {
      return {
        productId: product.id,
        productAttributes: product.attributes,
        productStatus: product.status,
      };
    });

    return {
      products: products,
      totalCount: data.totalCount as number,
    };
  } catch (e) {
    console.error('Variety planner failed products to:', e);
    return { products: [], totalCount: 0 };
  }
};
